import Phaser from "phaser";
import { FishBase } from "./FishBase";

export class BassAI extends FishBase {
    private readonly mode: "oval" | "zigzag";
    private phase = Phaser.Math.FloatBetween(0, Math.PI * 2);

    constructor(scene: Phaser.Scene, x: number, y: number, species: "Largemouth Bass" | "Smallmouth Bass", textureKey: string) {
        super(scene, x, y, {
            species,
            textureKey,
            pointValue: 20,
            swimSpeed: species === "Largemouth Bass" ? 100 : 105,
        });
        this.mode = species === "Largemouth Bass" ? "oval" : "zigzag";
    }

    override update(): void {
        this.phase += 0.03;
        const vx = Math.cos(this.phase) * this.swimSpeed;
        const vy = this.mode === "oval" ? Math.sin(this.phase) * this.swimSpeed * 0.7 : Math.sign(Math.sin(this.phase * 2)) * this.swimSpeed * 0.75;
        this.swimWithBias(vx, vy);
    }
}
